import "./VentilatorVitalDataMobileView.scss";
import offlineIcon from "../../common/icons/svg/ventilator-offline.svg"
import standbyIcon from "../../common/icons/svg/no-ventilation.svg"
import VentilatorSetParams from '../VentilatorSetParams/VentilatorSetParams';
import VentilatorChart from '../VentilatorChart/VentilatorChart.jsx';
import DevicesTab from "../../container/PatientRightPanel/MachineTabs/DevicesTab.jsx";
import VentilatorMonitoringVitalsMobileView from "./VentilatorMonitoringVitalsMobileView.js";


const VentilatorVitalDataMobileView = ({
    props,
    visibleParameters,
}) => {


    if (props?.ventilatorHeartbeat?.isConnected) {

        if (props?.ventilatorHeartbeat?.user_enabled) {
            {
                return (
                    <div className='ventilator-vitals-container-mobile-view'>
                        {props?.ventilatorStandby?.ventilationStatus ? (
                            <>
                                <div className="ventilator-vitals-container-mobile-view-alarms">
                                    <DevicesTab
                                        activeVitalDevice={props.config.activeDevice}
                                        modeData={props.ventilatorModesData}
                                        bedId={props.bedId}
                                        alarmData={props.alarmData}
                                        handleSeeAllAlarms={props.handleSeeAllAlarms}
                                    />
                                </div>

                                <div className="ventilator-vitals-container-mobile-view-graphs">
                                    {!props.monitoringVitalsView ? (
                                        <VentilatorChart bedId={props.bedId} />
                                    ) : <VentilatorMonitoringVitalsMobileView visibleParameters = {visibleParameters} />}

                                </div>
                            </>
                        ) : (
                            <div className="standby-mobile-view">
                                <img
                                    className="not-in-use-image-mobile-view"
                                    src={standbyIcon}
                                    alt="Ventilator on Standby"
                                />
                                <h2 className="not-in-use-text-mobile-view">
                                    Ventilator is on Standby
                                </h2>
                            </div>
                        )}
                        <div className='ventilator-vitals-container-mobile-view-set-parameters'>
                            <VentilatorSetParams bedId={props.bedId} />
                        </div >
                    </div >
                )
            }

        } else {
            return (
                <div className='offline-mobile-view'>
                    <img className='not-in-use-image-mobile-view' src={offlineIcon} alt="Ventilator Offline" />
                    <h2 className='not-in-use-text-mobile-view'>HorizonView is Disabled</h2>
                </div>
            )
        }

    } else {
        return (
            <div className='offline-mobile-view'>
                <img className='not-in-use-image-mobile-view' src={offlineIcon} alt="Ventilator Offline" />
                <h2 className='not-in-use-text-mobile-view'>Ventilator is currently offline, possibly due to settings or poor internet connection; please check and ensure proper configuration for seamless monitoring.</h2>
            </div>
        )
    }
};

export default VentilatorVitalDataMobileView;